
import './modals';
import './templates';



// WEBPACK FOOTER //
// ./scripts/modules/index.js